import BaseService from "@/services/BaseService";
export default class HospitalService extends BaseService{
  constructor() {
    super('odoo/hospital');
  }

  async FindAllActive() {
    return await this.http.get(this._serviceName+'/', { params: {'active': true} });
  }
}
